import _ from 'lodash'
import { of } from 'rxjs'
import { first, switchMap } from 'rxjs/operators'

import { Alias } from '@skinsoft/types'
import { authoritySelectors } from '@skinsoft/selectors'
import { dbCacheDown } from '../dexie/cache-down'
import { STATS_KEYS } from '../dexie/stats-keys'
import { OfflineDataFetcher } from '../offline-data-fetcher'
import { AuthorityOfflineDataFetcher } from './authority-offline-data-fetcher'


export class AliasOfflineDataFetcher extends OfflineDataFetcher<Alias>{

    constructor() {
        super(dbCacheDown.alias, STATS_KEYS.alias)
    }

    public getByUser(userId: string) {
        return new AuthorityOfflineDataFetcher().fetchOneFromPredicate(
            authority => authoritySelectors.linkedAccount(authority) === userId
        )
            .pipe(
                first(),
                switchMap(
                    theLinkedAuthority => of(authoritySelectors.firstAlias(theLinkedAuthority))
                ),
            )
    }

}